// extracted by mini-css-extract-plugin
module.exports = {"tile":"styles_tile__1Gf7s","name":"styles_name__2wwaB","basename":"styles_basename__e9Ocx","extension":"styles_extension__chv62","compact":"styles_compact__J2xIJ"};